import { Layout, Overlay } from "matsuri-ui"
import { css } from "@emotion/react"
import { theme } from "../../theme"

interface FooterProps {
    children: React.ReactNode
    handleClose?: () => void
}

export const Footer = (props: FooterProps) => {
    return (
        <Overlay
            position={"bottom"}
            onClose={props.handleClose}
            css={css`
                right: 0px;
                left: 0px;
                max-width: ${theme.device.maxWidth}px;
                padding-bottom: 34px;
                color: #4a4a4a;
                background-color: rgba(255, 255, 255, 0.55);
                border-top: 1px solid #ffffff;
                backdrop-filter: blur(12px);
                /* FIXME https://github.com/matsuri-tech/matsuri-ui/issues/1646 */
                && {
                    margin: auto !important;
                }
            `}
        >
            <Layout.Column gap={2}>
                <Layout.Row nowrap>{props.children}</Layout.Row>
            </Layout.Column>
        </Overlay>
    )
}
